import { React } from "react";
import { Helmet } from "react-helmet-async";
import Header from "../../components/header/Header";
import Footer from "../../components/footer/Footer";
import { main_paige_title } from "../../constants/constants";

const Contact = () => {
  return (
    <div>
      <Helmet>
        <title>{main_paige_title} - Impressum</title>
      </Helmet>
      <Header />
      <main id="content1">
        <section className="pt-12 pb-10">
          <div className="container">
            <h2 className="fs-sm-40 mb-3 text-center">Kontaktiere uns</h2>
          </div>
        </section>
        <div className="pb-7">
          <div className="container">
            <div className="row no-gutters">
              <div className="col-md-8 mb-8 mb-md-0">
                <h2 className="fs-24 mb-2">Wir würden uns freuen, von Ihnen zu hören.</h2>
                <p className="mb-7">Wenn Sie Lob oder Kritik äußern möchten, oder tolle Produkte herstellen und mit uns zusammenarbeiten wollen, schreiben Sie uns eine Nachricht.</p>
                <form action="https://formsubmit.co/info@lumint.de" method="POST">
                  <div className="row mb-6">
                    <div className="col-sm-6">
                      <input type="text" name="name" className="form-control" placeholder="Ihre Name*" required />
                    </div>
                    <div className="col-sm-6">
                      <input type="email" name="email" className="form-control" placeholder="Ihre Email*" required />
                    </div>
                  </div>
                  <div className="form-group mb-4">
                    <textarea className="form-control" name="message" rows="6" placeholder="Nachricht hier ..."></textarea>
                  </div>
                  <button type="submit" className="btn btn-primary text-uppercase letter-spacing-05">
                    Absenden
                  </button>
                </form>
              </div>
              <div className="col-md-4 pl-xl-13 pl-md-6">
                <p className="font-weight-bold text-primary mb-3">Adresse</p>
                <address className="mb-6">
                  Denhardstraße. 24
                  <br />
                  41189 Mönchengladbach
                  <br />
                  Deutschland
                </address>
                <p className="font-weight-bold text-primary mb-2">Information</p>
                <p className="mb-0">
                  <a href="tel:00491716181197">+49 171 6181197</a>
                </p>
                <p className="mb-7">
                  <a href="mailto:info@lumint.de">info@lumint.de</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Contact;
